interface StreamingRowBehaviorOptions {
  isStreaming: boolean;
  isDbAiFirstCreationEnabled: boolean;
  isAiFieldStreaming: boolean;
  entryId: string;
  entryIdSelectedForProcessing: string | undefined;
}

interface StreamingEntryScrollTargetOptions {
  entryIdSelectedForProcessing: string | undefined;
  isAiFieldStreaming: boolean;
  isDbAiFirstCreationEnabled: boolean;
  isStreaming: boolean;
}

interface StreamingEntryScrollModeOptions {
  renderedEntryIds: ReadonlySet<string>;
  target: Exclude<StreamingEntryScrollTarget, { kind: 'none' }>;
}

export type StreamingEntryScrollTarget =
  | { kind: 'none' }
  | { entryId: string; kind: 'aifc' };

export const getStreamingEntryScrollTarget = ({
  entryIdSelectedForProcessing,
  isAiFieldStreaming,
  isDbAiFirstCreationEnabled,
  isStreaming
}: StreamingEntryScrollTargetOptions): StreamingEntryScrollTarget => {
  if (isStreaming && (isDbAiFirstCreationEnabled || isAiFieldStreaming)) {
    return entryIdSelectedForProcessing
      ? { entryId: entryIdSelectedForProcessing, kind: 'aifc' }
      : { kind: 'none' };
  }

  return { kind: 'none' };
};

export const getStreamingEntryScrollMode = ({
  renderedEntryIds,
  target
}: StreamingEntryScrollModeOptions): 'none' | 'position' => {
  return renderedEntryIds.has(target.entryId) ? 'none' : 'position';
};

export const getStreamingRowBehavior = ({
  isStreaming,
  isDbAiFirstCreationEnabled,
  isAiFieldStreaming,
  entryId,
  entryIdSelectedForProcessing
}: StreamingRowBehaviorOptions) => {
  const isTargetStreamingRow = isStreaming && entryId === entryIdSelectedForProcessing;

  return {
    shouldShowAifcStreamingVisuals:
      isTargetStreamingRow && isDbAiFirstCreationEnabled && !isAiFieldStreaming,
    shouldAutoScrollToStreamingRow:
      isTargetStreamingRow && (isDbAiFirstCreationEnabled || isAiFieldStreaming)
  };
};
